import React from 'react';
import SettingsForm from '../ui-kit/SettingsForm';

const Settings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm updateWidgetSettingsField={updateWidgetSettingsField} widgetSettings={widgetSettings}>
    <SettingsForm.Section>
      <SettingsForm.Section.Header>{I18n.t('general')}</SettingsForm.Section.Header>
      <SettingsForm.Section.Content>
        <SettingsForm.ToggleField
          fieldName="textToSpeech"
          label={I18n.t('dashboards.widget_archetypes.incident_message.settings.text_to_speech')}
        />
        {widgetSettings.textToSpeech && (
          <SettingsForm.InputField
            type="number"
            fieldName="textToSpeechRepeatCount"
            label={I18n.t('dashboards.widget_archetypes.incident_message.settings.text_to_speech_repeat_count')}
          />
        )}
        <SettingsForm.ToggleField
          fieldName="timeLimitCheck"
          label={I18n.t('dashboards.widget_archetypes.incident_message.settings.time_limit_check')}
        />
        {widgetSettings.timeLimitCheck && (
          <SettingsForm.InputField
            type="number"
            fieldName="timeLimit"
            label={I18n.t('dashboards.widget_archetypes.incident_message.settings.time_limit')}
          />
        )}
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
  </SettingsForm>
);

export default Settings;
